import { Repository } from "src/firebase/firestore/repository";
import { UsersBroadcastChannel } from "../types/broadcast-channels.entity";

export class UserBroadcastChannelsRepository extends Repository<UsersBroadcastChannel> {
  constructor() {
    super("user_broadcast_channels");
  }
}

export const userBroadcastChannelsRepository = new UserBroadcastChannelsRepository();
